/* eslint-disable react/require-default-props */
import { t, Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import MentionableInput from '@components/common/mentions/MentionableInput';
import { manageDropdownListener } from '@helpers/use_effect_callbacks';

const NewComment = ({
  onSubmit,
  versionKey,
  mentionableUsers,
  setMentionableUsers,
  setShowCommentsPostButton,
  showCommentsPostButton
}) => {
  const [commentCopy, setCommentCopy] = useState('');
  const [mentionedUsers, setMentionedUsers] = useState([]);

  const commentInput = useRef();
  const commentContainer = useRef();

  const handleSubmit = () => {
    // Track comment submission with Amplitude
    if (window.BFG?.amplitude?.enabled && window.amplitudeService) {
      // Extract version number from versionKey (format is typically attachment_id_version_number)
      const versionMatch = versionKey.match(/_(\d+)$/);
      const version = versionMatch ? parseInt(versionMatch[1], 10) : 1;
      const assetId = window.BFG?.currentAsset?.id || '';
      window.amplitudeService.trackEvent('LeaveComment-ButtonClicked', {
        elementName: 'LeaveComment',
        productArea: 'AssetModal',
        featureArea: 'WorkflowTab',
        'key properties': {
          assetId: assetId,
          version: version
        }
      });
    }
    onSubmit({ versionKey, note: commentCopy, mentionedUsers });
    setCommentCopy('');
    setShowCommentsPostButton(false);
  };

  const dropdownEventListenerCallback = (e) => {
    e.stopPropagation();
    setShowCommentsPostButton(false);
  };

  useEffect(() => {
    if (!commentCopy) {
      return manageDropdownListener(
        commentContainer,
        showCommentsPostButton,
        dropdownEventListenerCallback
      );
    }
    return undefined;
  }, [commentCopy, commentContainer, showCommentsPostButton]);

  return (
    <div
      ref={commentContainer}
      className={`comment-input-container ${showCommentsPostButton ? 'active' : ''}`}
    >
      <label htmlFor="comment-input" style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', border: 0 }}>
        Leave a comment
      </label>
      <MentionableInput
        content={commentCopy}
        htmlAttributes={{
          className: "edit-message",
          id: "comment-input",
          onFocus: () => setShowCommentsPostButton(true),
          placeholder: t`Leave a comment`,
        }}
        inputRef={commentInput}
        onChange={(content, ids) => { setCommentCopy(content); setMentionedUsers(ids); }}
        onSubmit={handleSubmit}
        providedData={mentionableUsers}
        setParentMentionableUsers={setMentionableUsers}
      />
      {showCommentsPostButton
        && (
          <button
            className="button primary sm post-button"
            onClick={handleSubmit}
            type="submit"
          >
            <Trans>Post</Trans>
          </button>
        )
      }
    </div>
  );
};

NewComment.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  versionKey: PropTypes.string.isRequired,
  mentionableUsers: PropTypes.arrayOf(PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
  })),
  setMentionableUsers: PropTypes.func.isRequired,
  setShowCommentsPostButton: PropTypes.func.isRequired,
  showCommentsPostButton: PropTypes.bool.isRequired
};

NewComment.defaultProps = {
  mentionableUsers: null
};

export default NewComment;
